import React from 'react';
import CondensedOrderSummary from './condensed_order_summary';
import { ApplePayButton } from './apple_pay_button';
import LoggedOutApplePayButton from './logged_out_apple_pay_button';
import { useApplePay } from './apple_pay_hook';
import { core_apimessages_CartItemAttributes as CartItemAttributes } from '../schemas/rql';

interface HoistedApplePayButtonProps {
  listingCurrencyCode: string;
  paymentMethodsConfig: string;
  payButtonType?: 'checkout' | 'plain';
  cartItemAttributes?: CartItemAttributes[];
}

interface Props {
  itemPlusShippingSubtotal: string;
  isLoggedOut: boolean;
  hoistedApplePayButtonProps: HoistedApplePayButtonProps;
}

function HoistedApplePayWrapper(props: Props) {
  const { paymentMethodsConfig, listingCurrencyCode, cartItemAttributes, payButtonType } = props.hoistedApplePayButtonProps;

  const { isAvailable } = useApplePay({
    paymentMethodsConfig,
    listingCurrencyCode,
  });

  if (!isAvailable) {
    return null;
  }

  return (
    <div className="checkout-cart-header">
      <CondensedOrderSummary
        itemPlusShippingSubtotal={props.itemPlusShippingSubtotal}
      />
      <div className="checkout-cart-header__button">
        <div className="checkout-cart-header__button--apple-pay">
          {props.isLoggedOut ? (
            <LoggedOutApplePayButton
              paymentMethodsConfig={paymentMethodsConfig}
              listingCurrencyCode={listingCurrencyCode}
              cartItemAttributes={cartItemAttributes}
              payButtonType={payButtonType}
              buttonLocation="hoisted"
            />
          ) : (
            <ApplePayButton
              paymentMethodsConfig={paymentMethodsConfig}
              listingCurrencyCode={listingCurrencyCode}
              payButtonType={payButtonType}
              buttonLocation="hoisted"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default HoistedApplePayWrapper;
